import React, { useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Signin from './Signin';
import Signup from './Signup';
import ResetPassword from './ResetPassword';
import VerifyAccount from './VerifyAccount';
import AppBar from './AppBar';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh'
  },
  image: {
    backgroundImage: `url(${
      navigator.userAgent.toLowerCase().indexOf('safari') != -1 &&
      navigator.userAgent.toLowerCase().indexOf('chrome') <= -1
        ? '/dg_static/website/images/auth-background.jpg'
        : '/dg_static/website/images/auth-background.webp'
    })`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    marginTop: -30,
    opacity: 0.8,
    [theme.breakpoints.up('sm')]: {
      backgroundSize: 'cover'
    },
    [theme.breakpoints.up('lg')]: {
      backgroundSize: 'contain'
    }
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  content: {
    marginTop: 80
  }
}));

export default function Auth(props) {
  const [mode, setMode] = useState('');
  const classes = useStyles();
  const { qtEngine, qtWindow, engine, user } = props;
  const pathname = window.location.pathname;

  function getForm() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isRef = urlParams.get('ref');
    switch (mode) {
      case 'signup':
        return <Signup goToSignIn={() => setMode('signin')} />;
      case 'reset':
        return (
          <ResetPassword
            goToSignIn={() => setMode('signin')}
            qtWindow={qtWindow}
            qtEngine={qtEngine}
            engine={engine}
            mode={mode}
          />
        );
      default:
        if (isRef) {
          return (
            <Signup
              goToSignIn={() => {
                window.history.pushState('', '', '/signin');
                setMode('signin');
              }}
            />
          );
        }
        return (
          <Signin qtWindow={qtWindow} changeMode={state => setMode(state)} />
        );
    }
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <AppBar qtWindow={qtWindow} />
      <Grid item xs={false} sm={7} lg={8} className={classes.image} />
      <Grid
        item
        xs={12}
        sm={5}
        lg={4}
        component={Paper}
        elevation={6}
        square
        className={classes.content}
      >
        <Router>
          <div>
            {mode === 'signin' ? (
              getForm()
            ) : pathname === '/verify_account' ? (
              <VerifyAccount user={user} />
            ) : (
              <Switch>
                <Route
                  exact
                  path="/user_account/password-reset/confirm/:uid/:token"
                  component={currentProps => (
                    <ResetPassword
                      {...currentProps}
                      goToSignIn={() => setMode('signin')}
                      mode={mode}
                      qtWindow={qtWindow}
                      qtEngine={qtEngine}
                      engine={engine}
                    />
                  )}
                />
                <Route path="*">{getForm()}</Route>
              </Switch>
            )}
          </div>
        </Router>
      </Grid>
    </Grid>
  );
}
